/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import RenderHtml from 'react-native-render-html';
import { View } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';

const htmlStr = `
  <h1 style="color: rgb(51, 51, 51);">Does SnapCalorie Work</h1>
  <p style="color: rgb(51, 51, 51);">Take a picture of any meal on a plate and our algorithm will tell you the calories, fat, carbs, and protein. SnapCalorie uses artificial intelligence to make educated guesses based on what it sees, like a nutritionist would.</p>
  <div>&nbsp;</div>
  <h3 style="color: rgb(51, 51, 51);">Effectiveness of Diet Tracking Apps</h3>
  <p style="color: rgb(51, 51, 51);">Many <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6543803/" target="_new">peer reviewed scientific papers</a> have shown the effectiveness of diet tracking apps as a whole. One of the factors most important to success with calorie tracking is consistent logging. A major painpoint people cite for dropping off from tracking is tedious and time consuming nature of calorie tracking. This is exaclty what SnapCalorie aims to solve with photo tracking. Photo tracking means you only spend seconds per meal instead of minutes!</p>
  <h3 style="color: rgb(51, 51, 51);">Effectiveness of Photo Logging</h3>
  <p style="color: rgb(51, 51, 51);">Our team of scientists published the first algorithm capable of out performing a professional nutritionist at calorie estimation with just a single photo. In this study they demonstrated average users get over 50% mean caloric error from portion size estimation alone! Photo based logging by comparison was as low as 16.5% error. Read more in the peer reviewed academic paper <a href="https://arxiv.org/abs/2103.03375" target="_new">here</a>.</p>
  <div>&nbsp;</div>
  <a href="https://www.snapcalorie.com/survey/ValidDevice" style="font-size: 20px; color: rgb(248, 245, 244); background-color: rgb(253, 114, 80); padding: 15px; border-radius: 20px; width: 200px; text-decoration: none; text-align: center; margin: auto;">Sign Up Now</a>
`;

const source = {
  html: htmlStr,
};
export default function DoesSnapCalorieWork({ navigation }: RootStackScreenProps<'Privacy'>) {
  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View style={{ alignSelf: 'center', paddingLeft: 40, maxWidth: 800 }}>
        <RenderHtml contentWidth={800} source={source} />
      </View>
    </SnapCalorieSitePage>
  );
}
